import { Row } from 'antd';
import styled from 'styled-components';

const SingleCurrentValueContainer = styled.div<{ align: string }>`
    width: 100%;
    height: 100%;
    text-align: ${({ align }) => align};
    display: inline-block;
`;

const StyledRow = styled(Row)`
    & + & {
        margin-top: 30px;
    }
`;

const SingleCurrentValueEntry = styled.div<{ fontSize: number }>`
    font-size: ${({ fontSize }) => `${fontSize}%`};
    display: block;
`;

const LabelContainer = styled.div`
    font-weight: bold;
    text-transform: uppercase;
`;

const TimeContainer = styled.div``;

const TimeContainerAbsolute = styled.div`
    font-size: 70%;
`;

const ValueContainer = styled.div``;

const ValueSpan = styled.span`
    font-weight: bold;
    line-height: 2;
    border-radius: 1em;
    min-width: 50px;
    background-color: #d9d9d9;
    padding: 0 1em;
    padding-top: 2px;
`;

export { LabelContainer, SingleCurrentValueEntry, SingleCurrentValueContainer, StyledRow, TimeContainer, TimeContainerAbsolute, ValueContainer, ValueSpan };
